import { Component } from '@angular/core';

@Component({
  selector: 'app-downloads',
  imports: [],
  templateUrl: './downloads.html',
  styleUrl: './downloads.scss',
})
export class Downloads {

}
